export function validateSupplierId(value, maxBytes = 128) {
  if (typeof value !== 'string' || !value || value !== value.trim() || [...value].some((char) => {
    const code = char.charCodeAt(0);
    return code < 32 || (code >= 127 && code <= 159);
  }) || new Blob([value]).size > maxBytes) {
    throw new Error(`Identifier must be unchanged text of 1–${maxBytes} UTF-8 bytes, without control characters or surrounding spaces.`);
  }
  return value;
}
export function parseDeviceImport(text) {
  const rows = []; let row = [], field = '', quoted = false, closed = false, delimiter;
  const finish = () => { row.push(field); field = ''; closed = false; };
  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    if (quoted) {
      if (char === '"' && text[i + 1] === '"') { field += '"'; i++; }
      else if (char === '"') { quoted = false; closed = true; }
      else field += char;
      continue;
    }
    if (char === '"') {
      if (field || closed) throw new Error('Quote the complete CSV field and escape embedded quotes.');
      quoted = true; continue;
    }
    if (!delimiter && [',', ';', '\t'].includes(char)) delimiter = char;
    if (char === delimiter) { finish(); continue; }
    if (char === '\n' || char === '\r') {
      if (char === '\r' && text[i + 1] === '\n') i++;
      finish(); if (row.some(Boolean)) rows.push(row); row = []; continue;
    }
    if (closed) throw new Error('Unexpected text after a closing CSV quote.');
    field += char;
  }
  if (quoted) throw new Error('CSV quote is not closed.');
  finish(); if (row.some(Boolean)) rows.push(row);
  const fields = ['deviceNo', 'password', 'deviceName'];
  if (rows[0]?.[0] === 'deviceNo') {
    const header = rows.shift();
    if (header.some((name) => !fields.includes(name)) || new Set(header).size !== header.length) throw new Error('CSV columns must be deviceNo, password and deviceName.');
    fields.splice(0, fields.length, ...header);
  }
  if (rows.length > 200) throw new Error('Import at most 200 devices per batch.');
  const seen = new Set();
  return rows.map((values, index) => {
    if (values.length > fields.length) throw new Error(`Row ${index + 1}: too many columns; quote identifiers containing delimiters.`);
    const record = Object.fromEntries(fields.map((name, i) => [name, values[i] || undefined]));
    validateSupplierId(record.deviceNo);
    if (seen.has(record.deviceNo)) throw new Error(`Row ${index + 1}: duplicate supplier identifier.`);
    seen.add(record.deviceNo);
    if (record.password && record.password.length > 100) throw new Error(`Row ${index + 1}: password exceeds 100 characters.`);
    if (record.deviceName) validateSupplierId(record.deviceName, 100);
    return record;
  });
}
